import { queryKeys } from '../../queries/queryKeys';
import { useApiMutation } from '../../queries/useApiMutation';
import { post } from '../../queries';

export const useForgotPasswordMutation = () => {
    const mutation = useApiMutation<{ email: string }>({
        invalidateQueryOnMutate: true,
        queryKey: queryKeys.auth(),
        mutationFn: ({ email }) => post(`identity/forgotPassword`, { email: email }),
    });

    return { ...mutation };
};
